require("prismjs/themes/prism-okaidia.css"); // code blocks inside mdx
require("prismjs/plugins/line-numbers/prism-line-numbers.css"); // show line numbers
require("prismjs/plugins/command-line/prism-command-line.css"); // fancy prompt on anything with shell or bash

// Reference: https://www.gatsbyjs.com/plugins/gatsby-remark-prismjs/
